module.exports = __webpack_public_path__ + "static/media/ohiGroup.244cde7c.svg";